<template>
  <div class="page-box">
    <div class="page-title" v-if="breadcrumblist.length !== 0">
      {{
        $i18n.locale === "zh"
          ? breadcrumblist[breadcrumblist.length - 1].name
          : breadcrumblist[breadcrumblist.length - 1].eName
      }}
    </div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item class="breadcrumb-active"
        ><i class="fa fa-dashboard"></i
        >{{ $t("shortNoun.workbench") }}</el-breadcrumb-item
      >
      <el-breadcrumb-item
        v-for="(item, index) in breadcrumblist"
        :key="index"
        class="breadcrumb-active"
      >
        {{ $i18n.locale === "zh" ? item.name : item.eName }}</el-breadcrumb-item
      >
    </el-breadcrumb>
  </div>
</template>

<script>
import { navigation } from "@/components/Navigation/data-zn2";
export default {
  data() {
    return {
      navigation,
      breadcrumblist: [],
    };
  },
  methods: {
    findNavPathDetailed(targetPath, navData) {
      const result = [];

      function findPath(nodes, path, level = 0) {
        for (const node of nodes) {
          // 创建节点副本，避免修改原数据
          const currentNode = {
            ...node,
            level,
            isLeaf: !node.children || node.children.length === 0,
          };

          const currentPath = [...path, currentNode];

          if (node.path === targetPath) {
            result.push(...currentPath);
            return true;
          }

          if (node.children && node.children.length > 0) {
            if (findPath(node.children, currentPath, level + 1)) {
              return true;
            }
          }
        }
        return false;
      }

      findPath(navData, []);
      return result;
    },
  },
  mounted() {
    this.breadcrumblist = this.findNavPathDetailed(
      this.$route.path,
      this.navigation
    );
  },
};
</script>
<style lang="scss" scoped>
.page-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .page-title {
    font-size: 18px;
    color: #000000;
  }
  .breadcrumb-active {
    color: #303133;
    font-weight: bolder;
    cursor: pointer;
    .fa {
      margin-right: 5px;
    }
  }
}
.el-breadcrumb__item {
  float: none;
}
</style>
